import React, { useState, useMemo } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useFilterContext } from "../head-bar/filter-context";
import { TagGroup } from "./group";
import { Cuisines } from "./cuisines";
import { CloseIcon } from "@/icons";
import Loading from "@/components/dc-loading";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import "./desktop.less";

export const FiltersDialog = observer(({ type, title, close }) => {
  const { state, setState, filterParams, loading, total, cleanFilter } =
    useFilterContext();
  const { t } = useTranslation();
  const [isModalOpen, setOpen] = useState(true);

  const handleCancel = () => {
    setOpen(false);
    close();
  };
  const toggle = (id, key) => {
    setState((prev) => {
      const val = prev[key] || [];
      if (val === id) {
        return { [key]: "" };
      }
      return { [key]: id };
    });
  };

  const okText = useMemo(() => {
    if (total > 0) {
      return t("Header.See {count}", { count: total });
    }
    return t("Header.No results found");
  }, [total]);

  return (
    <Modal
      width={483}
      visible={isModalOpen}
      onCancel={handleCancel}
      wrapClassName="desktop-filter-dialog"
      footer={null}
      zIndex={3000}
      closeIcon={<CloseIcon />}
    >
      <div className="desktop-filter-dialog-head">
        <div className="desktop-filter-dialog-head-title">{title}</div>
      </div>
      <div className="desktop-filter-dialog-body">
        {type === "location" && (
          <Location
            filterParams={filterParams}
            t={t}
            state={state}
            toggle={toggle}
          />
        )}
        {type === "filters" && (
          <All
            filterParams={filterParams}
            t={t}
            state={state}
            toggle={toggle}
          />
        )}
        {type === "cuisines" && (
          <Cuisines classNames={["desktop-filter-cuisines"]} />
        )}
      </div>
      <div className="desktop-filter-dialog-foot">
        <span className="ui-button" onClick={cleanFilter}>
          {t("Header.Clear all filters")}
        </span>
        <span
          className={cn("ui-button", { "ui-button--disabled": total == 0 })}
          type="primary"
          onClick={handleCancel}
        >
          {loading ? <Loading></Loading> : okText}
        </span>
      </div>
    </Modal>
  );
});

const All = ({ filterParams, t, state, toggle }) => {
  return (
    <>
      <TagGroup
        title={t("Header.Recommended")}
        list={filterParams.tags}
        name="tags.id"
        styles={{ marginTop: 0 }}
        showAll={true}
      />
      <div className="head-filter-group">
        <div className="head-filter-title">{t("Browse.price_range")}</div>
        <div className="head-filter-list">
          {filterParams.price_range.map((item, index) => {
            let val = [item.start_price, item.end_price].join(",");
            return (
              <div
                className={cn("filter__tag", {
                  "filter__tag--active": state.avg_price === `${val}`,
                })}
                key={index}
                onClick={() => toggle(val, "avg_price")}
              >
                {item.view_price}7
              </div>
            );
          })}
        </div>
      </div>

      <div className="head-filter-group">
        <div className="head-filter-title">{t("Browse.distance")}</div>
        <div className="head-filter-list">
          {filterParams.distance.map((item, index) => {
            let val = item + "m";
            return (
              <div
                className={cn("filter__tag", {
                  "filter__tag--active": state.distance === `${val}`,
                })}
                key={index}
                onClick={() => toggle(val, "distance")}
              >
                {`< ${item}m`}
              </div>
            );
          })}
        </div>
      </div>
      <TagGroup
        title={t("Browse.district")}
        list={filterParams.locations}
        name="location.id"
        showAll={true}
      />
      <TagGroup
        title={t("Browse.landmarks")}
        list={filterParams.landmarks}
        name="landmarks.id"
        showAll={true}
      />
      <Cuisines />
      <TagGroup
        title={t("Browse.tags")}
        list={filterParams.extras}
        name="extras.id"
        showAll={true}
      />
    </>
  );
};
const Location = ({ filterParams, t, state, toggle }) => {
  return (
    <>
      <div className="head-filter-group" style={{ marginTop: 0 }}>
        <div className="head-filter-title">{t("Browse.distance")}</div>
        <div className="head-filter-list">
          {filterParams.distance.map((item, index) => {
            let val = item + "m";
            return (
              <div
                className={cn("filter__tag", {
                  "filter__tag--active": state.distance === `${val}`,
                })}
                key={index}
                onClick={() => toggle(val, "distance")}
              >
                {`< ${item}m`}
              </div>
            );
          })}
        </div>
      </div>
      <TagGroup
        title={t("Browse.district")}
        list={filterParams.locations}
        name="location.id"
        showAll={true}
      />
      <TagGroup
        title={t("Browse.landmarks")}
        list={filterParams.landmarks}
        name="landmarks.id"
        showAll={true}
      />
    </>
  );
};
